
// NEW - в чате только сообщения абонента, наших ответов нет
export const ChatStatusNew = 0;

// CHAT - есть хотябы один наш ответ
export const ChatStatusChat = 1;

// RESOLVED - решено
export const ChatStatusResolved = 2;

// INACTIVE - сессия кончилась для ответа
export const ChatStatusInactive = 3;

export const ChatStatusMap = {
  [ChatStatusNew]: 'new',
  [ChatStatusChat]: 'chat',
  [ChatStatusResolved]: 'resolved',
  [ChatStatusInactive]: 'inactive',
};

// Accepted from client/manager.
export const MessageStatusAccepted = 0;

// Sent to external channel.
export const MessageStatusSent = 1;

// Delivered to client.
export const MessageStatusDelivered = 2;

// TTL was expired and message wasn't delivered to client.
export const MessageStatusExpired = 3;

// Was seen by client/manager.
export const MessageStatusSeen = 4;

// Edited by client.
export const MessageStatusEdited = 5;

// Deleted by client/manager.
export const MessageStatusDeleted = 6;

// Failed to deliver.
export const MessageStatusFailed = 7;

export const MessageStatusMap = {
  [MessageStatusAccepted]: 'accepted',
  [MessageStatusSent]: 'sent',
  [MessageStatusDelivered]: 'delivered',
  [MessageStatusExpired]: 'expired',
  [MessageStatusSeen]: 'seen',
  [MessageStatusEdited]: 'edited',
  [MessageStatusDeleted]: 'deleted',
  [MessageStatusFailed]: 'failed',
};

export const TypeOutgoing = 'outgoing';
export const TypeIncoming = 'incoming';

// Sent by client.
export const EmitterClient = 0;

// Sent by tenant/manager.
export const EmitterUser = 1;

// Sent by delivery.
export const EmitterDelivery = 2;

// Sent by bot.
export const EmitterBot = 3;

